import { GetStaticProps } from 'next';
import { BusinessPageId } from '../../../features/app/pages/domain/constants/PageId';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import {
	GenericLandingPage,
	IGenericLandingPageProps,
} from '../../../features/app/pages/ui/GenericLandingPage';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import {
	BUSINESS_HOME_HEADER_DESKTOP,
	BUSINESS_HOME_HEADER_MOBILE,
} from '../../../features/shared/api/contentful/constants';
import { getHeaderImages } from '../../../features/shared/layout/header/image/getHeaderImages';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IGenericLandingPageProps> =
	createGetStaticPropsWithPage(BusinessPageId.Home, {
		headerImages: () =>
			getHeaderImages(
				BUSINESS_HOME_HEADER_DESKTOP,
				BUSINESS_HOME_HEADER_MOBILE,
			),
	});

export default GenericLandingPage;
